import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useSubscription } from "utils/useSubscription";

import PlansPrice from "../SharedComponents/Price";
import VATerms from "../SharedComponents/VATerms";
import { PlanAction, getCurrentPlanButton } from "../helpers";

const MobilePlanCardVirtualAssistant = () => {
  const { onPlanButtonClick } = useSubscription();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription } = useContext(SubscriptionContext);
  const action = getCurrentPlanButton(
    Plans.VA,
    subscription?.subscription?.planName || Plans.FREE,
    subscription,
  );

  return (
    <Box sx={{ backgroundColor: "white", borderRadius: 3, mt: 1 }}>
      <Grid container justifyContent={"flex-end"} sx={{ pr: 1, pt: 1 }}>
        <Box
          sx={{
            backgroundColor: "purple.main",
            borderRadius: 6,
            px: 2,
            py: 0.5,
            fontSize: 11,
            mb: 2,
            fontWeight: 600,
          }}
        >
          33x more likely to land a deal
        </Box>
      </Grid>

      <Box sx={{ px: 3, pb: 3 }}>
        <Grid container justifyContent="space-between" alignItems="flex-end">
          <Typography variant="h4" sx={{ fontSize: 26 }}>
            AI Virtual <br />
            Assistant
          </Typography>
          <PlansPrice plan={Plans.VA} />
        </Grid>

        <Divider sx={{ my: 1, backgroundColor: "black" }} />

        <Typography>
          <strong>Includes everything in Pro, plus:</strong>
        </Typography>

        <Typography sx={{ fontSize: 14, lineHeight: 2 }}>
          ⚡ 300 automated pitches send per month
          <br />
          💸 Exclusive brand pay data <br />
          🔐 Entire database of contacts <br />
        </Typography>

        {!currentOrg?.overridePlanName && (
          <Button
            disableElevation
            fullWidth
            variant={action === PlanAction.upgrade ? "contained" : "text"}
            sx={{
              fontSize: 16,
              mt: 2,
              py: 1,
              borderRadius: 2,
              backgroundColor:
                action === PlanAction.upgrade ? "black" : "#f4f8f6",
            }}
            onClick={() => onPlanButtonClick(Plans.VA, action)}
          >
            Upgrade to AI Assistant
          </Button>
        )}

        <Grid container justifyContent={"center"} sx={{ mt: 1 }}>
          <VATerms plan={Plans.VA} />
        </Grid>

        <Typography
          textAlign="center"
          sx={{ fontSize: 12, mt: 2, color: "#BA2709" }}
        >
          ⚠️ Virtual Assistant will increase to $72/mo (or $650/yr) after Feb
          20.
        </Typography>
      </Box>
    </Box>
  );
};

export default MobilePlanCardVirtualAssistant;
